<template>
  <el-dialog class="whd-percomm" title="个人佣金明细" :visible.sync="dialogVisible" @close="$emit('update:visible',false)" width="70%">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="个人资料" name="first">个人资料</el-tab-pane>
      <el-tab-pane label="分销订单历史" name="second">分销订单历史</el-tab-pane>
    </el-tabs>      
    <div class="whd-percomm-info" v-if="activeName=='first'">
      <div class="weui-cell pb0">
        <div class="weui-cell__hd"><img class="whd-img-cover" :src="userInfo.avatar" alt=""></div>
        <div class="weui-cell__hd pl20">申请人：{{userInfo.nickName}}</div>
        <div class="weui-cell__hd pl20">电话：{{userInfo.mobile}}</div>
        <!-- <div class="weui-cell__hd pl20">银行卡号：</div> -->
        <div class="weui-cell__bd"></div>
      </div>
      <el-divider></el-divider>
      <div class="form">       
        <el-row>
          <el-col :span="8"><div class="grid-content">总佣金：&yen;{{userInfo.all_commission}}</div></el-col>
          <el-col :span="8"><div class="grid-content">已提现：&yen;{{userInfo.commission_have}}</div></el-col>
          <el-col :span="8"><div class="grid-content">可提现：&yen;{{userInfo.commission}}</div></el-col>
        </el-row>
        <el-row>
          <el-col :span="8"><div class="grid-content">在途：&yen;{{userInfo.incoming}}</div></el-col>
          <el-col :span="8"><div class="grid-content">未入账：&yen;{{userInfo.unbooked}}</div></el-col>
          <el-col :span="8"><div class="grid-content">已扣减：&yen;{{userInfo.commission_discount}}</div></el-col>
        </el-row>        
      </div>
    </div> 
    <div class="whd-percomm-list" v-if="activeName=='second'">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <!--<span>{{ props.row.name }}</span>-->
            <el-table :data="props.row.goods_list" style="width: 100%">
              <el-table-column prop="date" label="商品图片" width="180">
                <template slot-scope="scope">
                  <img :src="scope.row.goods_thumb" alt="" width="50" height="50">
                </template>
              </el-table-column>
              <el-table-column prop="goods_name" label="商品名称" width="180"></el-table-column>
              <el-table-column prop="price_num" label="单价/数量"></el-table-column>
              <el-table-column prop="all_price" label="商品总价"></el-table-column>   
              <el-table-column prop="amount" label="应付"></el-table-column>   
              <el-table-column prop="discount" label="优惠"></el-table-column>                                                
              <el-table-column prop="user_commission" label="分销佣金"></el-table-column>
              <el-table-column prop="consignee" label="收货人"></el-table-column>     
              <el-table-column prop="order_status" label="状态"></el-table-column>                               
              <el-table-column prop="sale_discount" label="售后扣减数量"></el-table-column>
              <el-table-column prop="dis_commission" label="扣减佣金"></el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" prop="order_sn"></el-table-column>
        <el-table-column label="完成时间" prop="finish_time"></el-table-column>
      </el-table>
      <div class="pag_wrap" v-if="page.total!==0">
        <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="prev, pager, next"
            :total="page.total"></el-pagination>     
      </div>      
    </div>
  </el-dialog>   
</template>>

<script>
import api from "@/api.js";
import {pagination} from "@/util/util.js";
export default {
  name: "personalCommissionDetail",
  props: ["visible","employeeId"],
  data() {
    return{
      activeName: "first",
      dialogVisible: false,
      page: 1,
      total: 1,
      userInfo: {},
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      }
    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
      this.activeName = "first";
      if (this.dialogVisible) {
        this.InitFn(0)     
      }
    }
  },
  methods: {
    InitFn(num) {
      this.axios
          .post(api.financial_person_detail, {user_id: this.employeeId})
          .then(response => {
            if (response.data.code == 0) {
              if (num === 0) {
                this.userInfo = response.data.userInfo;
              }
              this.tableData = response.data.list;
              this.page.total = response.data.all_page;
            } else {
            }
          })
          .catch(response => {
          });
    },
    handleClick(tab, event) {
      if (tab.index==0) {
        //个人资料
      } else {
        //历史
      }
    },
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.InitFn(1);
    }
  }
}
</script>